import { takeLatest, call, put } from 'redux-saga/effects';
import { currentBranch, getSuccess, getFailure, postSuccess, postFailure, deleteSuccess, deleteFailure, putSuccess, putFailure, getReferralBranchSuccess,  getReferralBranchFailure } from './slice';
import { apiGet, apiPost, apiPut, apiDelete, apiUpload } from '../../../api/client';
function* getRequest() {
    try {
const response = yield call(apiGet, 'api/branch');
        if (response?.data?.length > 0) {
            let defaultBranch = JSON.parse(sessionStorage.getItem('defaultBranch')||'{}');
            if(defaultBranch && !defaultBranch?.id){
                defaultBranch = { name: response.data[0].name, id: response.data[0]._id };
            }
            yield put(currentBranch(defaultBranch));
        }
        yield put(getSuccess(response));
    } catch (error) {
        yield put(getFailure(error?.response?.message || error));
    }
}
function* postRequest(action) {
    try {
        const response = yield call(apiPost, 'api/branch', action.payload);
        yield put(postSuccess(response));
    } catch (error) {
        yield put(postFailure(error?.response?.message || error));
    }
}

function* deleteRequest(action) {
    try {
        const response = yield call(apiDelete, `api/branch/${action.payload}`);
        yield put(deleteSuccess(response));
    } catch (error) {
        yield put(deleteFailure(error?.response?.message || error));
    }
}

function* putRequest(action) {
    try {
        const response = yield call(apiPut, 'api/branch', action.payload);
        yield put(putSuccess(response));
    } catch (error) {
        yield put(putFailure(error?.response?.message || error));
    }
}

function* getReferralBranch() {
    try {
const response = yield call(apiGet, 'api/referral-branch');
        yield put(getReferralBranchSuccess(response?.data));
    } catch (error) {
        yield put(getReferralBranchFailure(error?.response?.message || error));
    }
}


function* saga() {
    yield takeLatest('branch/getRequest', getRequest);
    yield takeLatest('branch/postRequest', postRequest);
    yield takeLatest('branch/deleteRequest', deleteRequest);
    yield takeLatest('branch/putRequest', putRequest);
    yield takeLatest('branch/getReferralBranch', getReferralBranch);
}

export default saga;